import { useEffect, useState } from 'react';
import { api } from '../api';
import { sar } from '../format';

interface Dead { item: string; qty: number; days_stale: number; value: number }
interface Low { item: string; qty: number; reorder_level: number }
interface Reorder { item: string; suggested_qty: number; vendor: string }
interface Payload {
  lens: 'L04'; date: string;
  dead_stock_top10: Dead[];
  low_stock: Low[];
  reorder_suggestions: Reorder[];
  _meta: { phase: number; mode: string; source: string };
}

export function LensInventory() {
  const [data, setData] = useState<Payload | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => { api<Payload>('/lenses/L04').then(setData).catch((e) => setErr(String(e))); }, []);
  if (err) return <div className="lens error">خطأ: {err}</div>;
  if (!data) return <div className="lens">جارٍ التحميل…</div>;

  const deadValue = data.dead_stock_top10.reduce((s, d) => s + d.value, 0);

  return (
    <div className="lens">
      <header>
        <h2>L04 — المخزون</h2>
        <span className="badge">{data.date}</span>
        <span className="badge src">{data._meta.source}</span>
      </header>

      <section className="widgets">
        <div className="widget"><h3>Dead Stock</h3><p className="big">{sar(deadValue)}</p><p className="hint">{data.dead_stock_top10.length} صنف ≥ 90 يوم</p></div>
        <div className="widget"><h3>منخفض</h3><p className="big">{data.low_stock.length}</p><p className="hint">تحت reorder level</p></div>
        <div className="widget"><h3>اقتراحات طلب</h3><p className="big">{data.reorder_suggestions.length}</p><p className="hint">جاهزة للموافقة</p></div>
      </section>

      <section className="panel">
        <h3>Dead Stock — Top {data.dead_stock_top10.length}</h3>
        <table className="banks">
          <thead><tr><th>الصنف</th><th>الكمية</th><th>أيام راكدة</th><th>القيمة</th></tr></thead>
          <tbody>
            {data.dead_stock_top10.map((d) => (
              <tr key={d.item}>
                <td>{d.item}</td>
                <td className="num">{d.qty}</td>
                <td className="num">{d.days_stale}</td>
                <td className="num">{sar(d.value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="panel">
        <h3>تنبيهات النفاد</h3>
        <ul className="cards">
          {data.low_stock.map((l) => (
            <li key={l.item} className="card u-warn">
              <div className="card-head">
                <span className="pill u-warn">منخفض</span>
                <span className="amount">{l.qty} / {l.reorder_level}</span>
              </div>
              <p className="card-title">{l.item}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="panel">
        <h3>اقتراحات الطلب</h3>
        <ul className="cards">
          {data.reorder_suggestions.map((r) => (
            <li key={r.item} className="card u-info">
              <div className="card-head">
                <span className="pill u-info">اقتراح</span>
                <span className="lens-tag">{r.vendor}</span>
                <span className="amount">{r.suggested_qty} وحدة</span>
              </div>
              <p className="card-title">{r.item}</p>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
